export const VARIANTS = {
  BOLD: 'bold',
  SEMIBOLD: 'semibold'
}
